export default __webpack_public_path__ + "static/uiuxcase2-37c0446e7d27b04692389fb59b10a1a1.png";